import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, LifeBuoy, ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "Comment ajouter une mission rapidement ?",
    a: "Utilisez « Ajouter en rafale » pour saisir rapidement plusieurs missions d'affilée, sans interrompre votre élan.",
  },
  {
    q: "Qu'est-ce qu'une expédition ?",
    a: "Une expédition transforme un objectif en aventure : vous suivez votre progression, vos missions accomplies et les points restants jusqu'à l'atteindre.",
  },
  {
    q: "Mes données sont-elles sauvegardées ?",
    a: "Oui. Vos missions, expéditions et votre progression sont sauvegardées avec votre compte afin que vous puissiez les retrouver lors de vos prochaines utilisations.",
  },
  {
    q: "V\u00c9LIS est-il gratuit ?",
    a: "Oui. Vous pouvez commencer à utiliser VÉLIS gratuitement. Des contenus ou options supplémentaires pourront être proposés séparément.",
  },
];

const FaqItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-2xl border border-white/10 bg-velis-card overflow-hidden">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
      >
        <span className="font-display font-semibold text-white">{q}</span>
        <ChevronDown
          size={20}
          className={`text-velis-orange shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
      {open && <p className="px-6 pb-5 text-white/70 leading-relaxed">{a}</p>}
    </div>
  );
};

const Support = () => (
  <main className="bg-velis-dark min-h-screen pt-28 pb-24">
    <div className="max-w-3xl mx-auto px-6">
      <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-8">
        <ArrowLeft size={16} /> Retour à l'accueil
      </Link>

      <div className="flex items-center gap-3 mb-3">
        <div className="w-11 h-11 rounded-xl bg-[var(--velis-orange)]/15 flex items-center justify-center">
          <LifeBuoy className="text-velis-orange" size={22} />
        </div>
        <h1 className="font-display font-extrabold text-white text-4xl">Support</h1>
      </div>
      <p className="text-white/70 mb-10 leading-relaxed">
        Une question ? Nous sommes là pour vous aider à garder le cap.
      </p>

      <div className="space-y-4 mb-14">
        {faqs.map((f) => (
          <FaqItem key={f.q} {...f} />
        ))}
      </div>

      <div className="rounded-3xl border border-white/10 bg-velis-card p-8 text-center">
        <h2 className="font-display font-bold text-white text-2xl">Besoin d'aide supplémentaire ?</h2>
        <p className="text-white/70 mt-2 mb-6">Écrivez-nous, nous répondons rapidement.</p>
        <a
          href="mailto:support@velisproductivity.com"
          className="inline-flex items-center justify-center gap-2.5 rounded-full bg-[var(--velis-orange)] hover:bg-[var(--velis-orange-light)] text-white font-semibold px-8 py-4 hover:-translate-y-0.5"
        >
          <Mail size={18} /> support@velisproductivity.com
        </a>
      </div>
    </div>
  </main>
);

export default Support;
